const NotificationSoundAlert = () => {
  const PF = process.env.REACT_APP_PUBLIC_FOLDER
  const alertSound = new Audio(`${PF}notification_alert.mp3`)
    alertSound.play()
}

export default NotificationSoundAlert
